import trim from 'underscore.string/trim';
import rtrim from 'underscore.string/rtrim';

let assetVersion = '';

export default {
    set assetVersion(url) {
        assetVersion = rtrim(url, ['/']);
    },

    get assetVersion() {
        return assetVersion;
    },

    assetUrl: function(filename) {
        var stripped = trim(filename, ['/']);
        return [assetVersion, stripped].join('/');
    }
};



// WEBPACK FOOTER //
// ./src/helpers/Assets.js